// src/stable/useStep.ts
import { useContext } from "react";
import { ActivityContext } from "../__internal__/activity/ActivityProvider.mjs";
function useStep() {
  var _a;
  const { steps, id } = useContext(ActivityContext);
  return (_a = steps.filter((step) => step.id !== id).at(-1)) != null ? _a : null;
}
export {
  useStep
};
